import React from 'react';
import { SunLoader } from './SunLoader.js';

/**
 * Заставка первого запуска: пока приложение узнаёт, кто вошёл и чьи профили.
 *
 * Та же картинка, что статическая заставка в `index.html`, которую браузер
 * показывает ещё до загрузки скриптов: React подменяет одну другой незаметно —
 * место, размер и фаза движения совпадают (фаза у индикатора отсчитана от
 * загрузки страницы). Голый текст «Загрузка…» в углу на этом месте выглядел
 * как сломанная страница, а не как приложение, которое просыпается.
 *
 * Подпись не видна, но остаётся текстом: её читает экранный диктор.
 */
export function AppSplash({ label }: { label: string }): React.JSX.Element {
  return (
    <main className="app-splash" role="status" aria-live="polite">
      <SunLoader className="app-splash-loader" />
      <span className="app-splash-label">{label}</span>
    </main>
  );
}
